<template>
    <button class="button is-info is-outlined map-button-round" @click="onClick" title="Печать карты">
        <span class="icon"><img src="../../../assets/svg/print.svg" width="16" height="16"/></span>
    </button>
</template>
<script>
	export default {	
		methods: {
			onClick() {
				window.print();
			}
		}
	};
</script>
<style scoped lang="scss">
</style>
